module.exports = __webpack_public_path__ + "img/mc_symbol.3c036285.svg";